<template>
    <v-footer class="back-color justify-center">
      <v-btn 
        href="https://edupluscampus.com/"
        target="_blank"
        text
        style="text-transform: none;font-size: 15px;color: #FFF;">© {{ new Date().getFullYear() }} EasyPariksha Powered by : : VGESPL </v-btn>
    </v-footer>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.back-color{
/* background: linear-gradient(90deg, hsla(217, 100%, 50%, 1) 0%, hsla(186, 100%, 69%, 1) 130%); */
    background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);
}
</style>